export const serverError = (errors) => {
  const errorMessage = Object.entries(errors)
    .map(([key, value]) => (key === "base" ? value : `${key} - ${value}`))
    .join(", ")
  return errorMessage
}
